import React from 'react';
import { UserVehicleDto } from 'Services/Api/_HumanWritten/UserVehicleService';
import { VehicleCard } from './VehicleCard';
import { LottieSpinner } from 'Views/Components/_HumanWritten/Lottie/LottieSpinner';
import { getLowerCaseMessageByKey, getPascalCaseMessageByKey } from 'Stores/LanguageStore';

export interface VehiclesListProps {
	vehicles: UserVehicleDto[] | null;
	isLoading: boolean;
	onRemove: (vehicleId: string) => void;
	onUpdate: () => void;
}

export function VehiclesList({ vehicles, isLoading, onRemove, onUpdate }: VehiclesListProps) {
	if (isLoading) {
		return (
			<div className="vehicles-list__loading">
				<LottieSpinner />
			</div>
		);
	}

	if (!vehicles || vehicles.length === 0) {
		return (
			<div className="vehicles-list__empty">
				<p>No {getLowerCaseMessageByKey('vehicle__name__label', 'vehicle')}s saved to your account.</p>
				<p className="vehicles-list__empty-hint">
					{getPascalCaseMessageByKey('vehicle__name__label', 'Vehicle')}s you use in bookings will appear
					here.
				</p>
			</div>
		);
	}

	return (
		<div className="vehicles-list">
			{vehicles.map(vehicle => (
				<VehicleCard
					key={vehicle.id}
					vehicle={vehicle}
					onRemove={() => onRemove(vehicle.id)}
					onUpdate={onUpdate}
				/>
			))}
		</div>
	);
}
